import React from 'react';
import { Redirect } from 'react-router-dom';

const AuthErrorRedirect = () => {
  return <Redirect to="/auth/error" />;
};

export default AuthErrorRedirect;
